import React, { useState } from 'react';

import './faq.scss';
import GuestLayout from '../layouts/GuestLayout';
import { Link } from '../hooks/router';

import articles from './articles';

export default function Faq({ route }) {
  return (
    <div className="faq-page">
      <div className="head">
        <div className="title">
          Bonjour,
          <br/>
          Comment pouvons-nous vous aider ?
        </div>
      </div>
      <div className="articles">
        {
          articles.map((article, key) => (
            <Link to="faqArticle" params={{ slug: article.slug }} key={article.slug} className="article">
              <h2>{article.title}</h2>
              { article.preview &&
                <div className="preview">{article.preview}</div>
              }
            </Link>
          ))
        }
      </div>
    </div>
  );
};
